import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Cliente } from '../../models/cliente';
import { Validation } from '../../config/validation';
import { SweetMessage } from '../../config/sweet-message';
import { ClienteService } from '../../services/cliente.service';
import { SessionService } from '../../services/session.service';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
	selector: 'app-cliente-basic-frm-add',
	templateUrl: './cliente-basic-frm-add.component.html',
	styleUrls: ['./cliente-basic-frm-add.component.css'],
	providers: [ClienteService, SessionService]
})
export class ClienteBasicFrmAddComponent implements OnInit {
	//@Output() sendCliente = new EventEmitter();
	@Input() btnCalelHidden: boolean = false;
    public cliente: Cliente;
	public vl: Validation;
	public title: String;
	myForm: FormGroup;
	private msgSweet: SweetMessage;
	public loading = false;
	public correos: Array<any>;

	constructor(
		public fb: FormBuilder,
		private clienteService: ClienteService,
		private ss: SessionService,
		public bsModalRef: BsModalRef,
		public bsModalRef2: BsModalRef,
	) {
		this.cliente = new Cliente();
		this.cliente.tipo_identificacion_id = 1;
		this.vl = new Validation();
		this.correos = [];
		this.msgSweet = new SweetMessage();
	}

	ngOnInit() {
		this.onForm();
		this.vl = new Validation();
		this.onForm();
	}

	isValidForm(){
		if(!this.cliente.nombre_comercial){
			return false;
		}
		if( !this.cliente.dni ){
			return false;
		}else{
			if( isNaN(parseInt(this.cliente.dni.toString())) ){
				return false;
			}
			if (this.cliente.dni.length < 10 ) {
				return false;
			}
			if (this.cliente.dni.length >10 && this.cliente.dni.length < 13) {
				return false;
			}
		}
		return true;
	}

	onSubmit(){
		this.loading = true;
		this.setValueEntity();
		//this.sendCliente.emit(this.cliente);
		//this.bsModalRef.hide();
		this.clienteService.saveByDni(this.cliente).subscribe(
			res => {
				this.loading = false;
				this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente');
				this.cliente = new Cliente();
				this.bsModalRef.hide();
			},
			err => {
				this.loading = false;
				this.msgSweet.showMessage('error-message',err);
			}
		);
	}

	setValueEntity(){
		this.cliente.dni = this.myForm.controls['dni'].value;
		this.cliente.nombre_comercial = this.myForm.controls['nombre'].value;
		this.cliente.empresa_id = this.ss.getData("empresa_id");
		this.cliente.usuario_id = this.ss.getData("usuario_id");
		this.cliente.correo = this.correos.toString();
		switch (this.cliente.tipo_identificacion_id){
			case 1: 
				this.cliente.tipo_dni = "RUC";
				break;
			case 2: 
				this.cliente.tipo_dni = "CED";
				break;
			case 3:
				this.cliente.tipo_dni = "PAS";
				break;
		}
	}

	onChangeIdentificacion(id){
		this.cliente.tipo_identificacion_id = id;
	}

	onForm() {
		this.myForm = this.fb.group({
			dni: ['', [Validators.required,Validators.pattern(/[A-Za-z0-9\s]*/)]],
			nombre: ['', [Validators.required,Validators.pattern(/[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ\s]*/)]],
			
		});
	}

	setValueForm() {
		this.myForm.setValue({
			nombre: this.cliente.nombre_comercial,
			dni: this.cliente.dni,
			
		});
	}
	

	validErrorForm(campo) {
		return this.vl.validErrorForm(campo, this.myForm);
	}

	validTypeMsgForm(nombre, campo) {
		return this.vl.validTypeMsgForm(nombre, campo, this.myForm);
	}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/forms/cliente-basic-frm-add/cliente-basic-frm-add.component.ts